export const CAROUSEL_ITEM_WIDTH = 160;
export const CAROUSEL_ITEM_HEIGHT = 102;
export const CAROUSEL_ITEM_GAP = 10;

export interface ISwipeableCarouselProps {
    elements: any[];
    admin?: boolean;
}
